import type {
  PaginatedEventRegistration,
  QueryEventRegistrationsArgs,
} from '@tribeplatform/gql-client/types'
import { EventRegistrationFields } from '@tribeplatform/gql-client/types/generated'

import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getEventRegistrationsKey } from './event.key.js'

export const useEventRegistrations = (options: {
  variables: QueryEventRegistrationsArgs
  fields?: EventRegistrationFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedEventRegistration>
}) => {
  const { variables, fields = 'all', useInfiniteQueryOptions } = options || {}
  const { client } = useTribeClient()
  const eventsListKey = getEventRegistrationsKey({ variables, fields })

  return useInfiniteQuery<PaginatedEventRegistration>(
    eventsListKey,
    ({ pageParam: after }) =>
      client.events.eventRegistrations({ after, ...variables }, fields),
    {
      ...useInfiniteQueryOptions,
    },
  )
}
